import React from 'react';
import Plans from '../../components/Plans';
import AppLayout from '../../layouts/AppLayout';
import './styles.css';

function PlansPage() {
  return (
    <AppLayout title="Planos" subtitle="Assinatura e limites" fullWidth>
      <Plans />
    </AppLayout>
  );
}

export default PlansPage;
